module.exports = __webpack_public_path__ + "img/outlineBorder2.6f921b6b.png";